import React, { useContext } from 'react'
import gql from 'graphql-tag'
import { useState } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { itemType, s3fileType } from '../types'
import S3FileListTable from './item/S3FileListTable'
import UserContext from '../contexts/UserContext'
import { useLocation } from 'react-router-dom'
import { format } from 'react-string-format'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const reload = () => window.location.reload()

const GET_S3OBJECTS_QUERY = gql`
    mutation GetS3ObjectsQuery($input: GetS3ObjectsInput!) {
        getS3Objects(input: $input) {
            s3Objects {
                Key
                LastModified
                ETag
                Size
                StorageClass
                TargetFileSize
            }
        }
    }
`

const GET_UPLOADFILES_QUERY = gql`
    mutation UploadQuery($input: UploadS3FilesInput!) {
        uploadS3Files(input: $input) {
            id
        }
    }
`

export default function S3FileuploadModal(props) {
  const [showS3Files, setShowS3Files] = useState(false)
  const [showS3Options, setShowS3Options] = useState(true)
  const [overwriteFileList, setOverwriteFileList] = useState([])
  const [filepath, setFilepath] = useState('')
  const [s3objectlists, setS3objectlists] = useState([])
  const [s3filelists, setS3Filelists] = useState([])
  const [confirmModalOn, setConfirmModalOn] = useState(false)
  const [confirmHeaderMsg, setConfirmHeaderMsg] = useState(null)
  const [confirmBodyMsg, setConfirmBodyMsg] = useState(null)
  const [alertModalOn, setAlertModalOn] = useState(false)
  const [alertHeaderMsg, setAlertHeaderMsg] = useState(null)
  const [alertBodyMsg, setAlertBodyMsg] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)
  const [showClose, setShowClose] = useState(false)
  const { item, itemFilesCount, fileUploadLimit, uploadLimitMessageHeader, uploadLimitMessage } = props
  const { username } = useContext(UserContext)

  const [getS3Objects] = useMutation(
    GET_S3OBJECTS_QUERY,
    {
      variables: {
        input: {
          id: item.id,
          key: filepath
        }
      }
    }
  )

  const [uploadS3Files] = useMutation(
    GET_UPLOADFILES_QUERY,
    {
      variables: {
        input: {
          filelist: s3filelists,
          id: item.id,
          key: filepath,
          username: username
        }
      }
    }
  )

  const handleCloseS3Object = () => {
    // setShowS3(false)
    reload()
  }

  const handlePullS3Object = () => {
    setS3objectlists([])
    setOverwriteFileList([])

    getS3Objects().then(
      result => {
        let s3FileList = result.data.getS3Objects.s3Objects
        let existingFiles = item.fileConnection.files
        s3FileList.forEach(obj1 => {
          let matchedObj = existingFiles.find(obj2 => obj2.name === obj1.Key && obj2.location === 's3')
          if (matchedObj) {
            obj1.TargetFileSize = parseInt(matchedObj.size)
            setOverwriteFileList(overwriteFileList => [...overwriteFileList, matchedObj.name])
          }
        })

        setS3objectlists(s3FileList)
        setShowS3Files(true)
      },
      error => {
        console.log('Get S3 object list failed with error ', error)
        // handle the error here
      }
    )
    // props.onHide()
  }

  const location = useLocation()
  let filterFileList = []

  const selectionVerification = () => {
    filterFileList = []
    if (overwriteFileList.length > 0)
      console.log('Find existing files ', overwriteFileList)
    s3filelists.forEach(obj1 => {
      let matchedObj = overwriteFileList.find(obj2 => obj2 === obj1)
      if (matchedObj) {
        //setOverwriteFileList(overwriteFileList => [...overwriteFileList, matchedObj.id])
        filterFileList.push(matchedObj)
      }
    })

    var limit = fileUploadLimit - itemFilesCount
    console.log(`ItemFilesCount ${itemFilesCount}, FileuploadLimit ${fileUploadLimit}, Remaining Max Upload ${limit}`)
    console.log(`s3filelists.length ${s3filelists.length}, filterFileList.length ${filterFileList.length}`)
    if ((s3filelists.length - filterFileList.length) > limit) {
      let alertMessage = format(uploadLimitMessage, limit)
      let maxFileAlertMessage = alertMessage.split('\n').map(i => {
        return <p key={i}>{i}</p>
      })
      setAlertModalOn(true)
      setAlertHeaderMsg(uploadLimitMessageHeader)
      setAlertBodyMsg(maxFileAlertMessage)
      return false
    }

    if (filterFileList.length > 0) {
      let alertMessage = 'This ScienceBase item currently already has a file with the same filename attached. If you elect to upload the selected file, it will overwrite the current file. Proceed?\n'
      const fileListRawMessage = '\n  .  ' + filterFileList
        .filter(f1 => s3filelists.some(f2 => f1 === f2))
        .map(filename => filename)
        .join('\n  .  ')
      let fileListMessage = fileListRawMessage.split('\n').map(i => {
        return <p key={i}>{i}</p>
      })
      console.log('Warning for overwrite files ', filterFileList)
      setConfirmModalOn(true)
      setConfirmHeaderMsg(alertMessage)
      setConfirmBodyMsg(fileListMessage)
    } else {
      handleUploadS3()
    }
  }

  const handleUploadS3 = async () => {
    if (s3filelists != null && s3filelists.length > 0) {
      setIsLoading(true)
      uploadS3Files().then(
        result => {
          console.log('Upload S3 files result \n', result)
          setShowClose(true)
          setIsLoading(false)
          setIsComplete(true)
          setShowS3Options(false)
        },
        error => {
          console.log('Upload S3 files failed with error ', error)
          // Network error means upload job times out at gateway but is still in progress. Show popup to let user know
          if (error && error.message === 'Network error: Failed to fetch') {
            setShowClose(true)
            setIsLoading(false)
            setIsComplete(true)
            setShowS3Options(false) 
          }
        }
      )
    } else {
      console.log('No file was selected for upload')
    }
  }

  const closeConfirmModal = () => {
    setConfirmModalOn(false)
    //props.onHide()
    filterFileList = []
  }
  const closeAlertModal = () => {
    setAlertModalOn(false)
    filterFileList = []
  }

  return (
    <div>
      <Modal {...props} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{showS3Options ? 'You are about to upload S3 file from your S3 bucket for this item, please provide the S3 file path (such as: s3://mys3bucket/12)' : 'Files Successfully Uploaded'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            showS3Options && (
              <table>
                <tbody>
                  <tr>
                    <th width='150px'>S3 Bucket Path: </th>
                    <td width='450px'>
                      <input type='text' value={filepath} style={{ width: 400 + 'px' }} onChange={event => { setFilepath(event.target.value) }} />
                    </td>
                    <td width='50px'>
                      <Button variant="secondary" onClick={handlePullS3Object}>Retrieve</Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
          }
          <div>
            {
              showS3Files && showS3Options && (
                <S3FileListTable
                  location={location}
                  childItems={s3objectlists}
                  setS3Filelists={setS3Filelists}
                />
              )
            }
          </div>

        </Modal.Body>
        <Modal.Footer>
          {
            showS3Files && (
              <div className="modal-content border-0">
                <div className="list-group text-center">
                  {(s3filelists.length > 0) && (
                    <ul>
                      {showS3Options ? 'You selected the following S3 file(s):' : 'You have uploaded the following S3 file(s):'}

                      {s3filelists.map(listitem => (
                        <li className="list-group-item border-0" key={listitem}>
                          {filepath.endsWith('/')? filepath.substring(0, filepath.length - 1): filepath}/{listitem}
                        </li>
                      ))}

                      {showS3Options ? '' : <div><br /><p><b>{'For large files, please note that this may take some time to complete.'}</b></p></div>}
                    </ul>
                  )}
                </div>
                <div className="text-right">
                  {isComplete ? '' : <Button variant="primary" className="btn btn-primary" show={showS3Files.toString()} onClick={selectionVerification}>{isLoading ? <span ><FontAwesomeIcon icon={faSpinner} pulse /></span> : ''}&nbsp;{'Upload Selected Files'}</Button>}
                  &nbsp;&nbsp;
                  <Button variant="secondary" className="btn btn-secondary" disabled={isLoading} onClick={handleCloseS3Object}>{!showClose ? 'Cancel' : 'Close'}</Button>
                </div>
              </div>
            )
          }
        </Modal.Footer>
      </Modal>
      {
        confirmModalOn && (
          <Modal show={confirmModalOn} onHide={closeConfirmModal}>
            <Modal.Header>
              <Modal.Title>{confirmHeaderMsg}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{confirmBodyMsg}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeConfirmModal}>No</Button>
              <Button variant="primary" onClick={() => { handleUploadS3(); closeConfirmModal() }}>Yes</Button>
            </Modal.Footer>
          </Modal>
        )
      }
      {
        alertModalOn && (
          <Modal show={alertModalOn} onHide={closeAlertModal}>
            <Modal.Header id="modal-header-alert">
              <Modal.Title>{alertHeaderMsg}</Modal.Title>
            </Modal.Header>
            <Modal.Body >{alertBodyMsg}</Modal.Body>
            <Modal.Footer style={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant="secondary" onClick={closeAlertModal}>OK</Button>
            </Modal.Footer>
          </Modal>
        )
      }
    </div>
  )
}

S3FileuploadModal.propTypes = {
  item: itemType,
  onHide: PropTypes.func,
  itemFilesCount: PropTypes.number,
  fileUploadLimit: PropTypes.number,
  uploadLimitMessageHeader: PropTypes.string,
  uploadLimitMessage: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  s3filelist: PropTypes.arrayOf(s3fileType),
  filepath: PropTypes.string
}
